//export const gtmCode = `GTM-WVKXZQRK`;//
export const gtmCode = `G-1SXPYV6WBT`;// 